const natureAreas = [
  { name: 'Kalmthoutse Heide', province: 'Antwerpen', coordinates: [4.475, 51.405] },
  { name: 'Nationaal Park Hoge Kempen', province: 'Limburg', coordinates: [5.58, 50.99] },
  { name: 'Zwin Natuur Park', province: 'West-Vlaanderen', coordinates: [3.365, 51.355] },
  { name: 'Hallerbos', province: 'Vlaams-Brabant', coordinates: [4.27, 50.72] },
  { name: 'Bourgoyen-Ossemeersen', province: 'Oost-Vlaanderen', coordinates: [3.65, 51.08] },
  { name: 'Mechelse Heide', province: 'Limburg', coordinates: [5.63, 50.98] },
  { name: 'De Westhoek', province: 'West-Vlaanderen', coordinates: [2.58, 51.06] },
  { name: 'Landschap De Liereman', province: 'Antwerpen', coordinates: [5.08, 51.39] },
  { name: 'Hobokense Polder', province: 'Antwerpen', coordinates: [4.36, 51.17] },
  { name: 'Het Vinne', province: 'Vlaams-Brabant', coordinates: [5.11, 50.86] },
  { name: 'Blaasveldbroek', province: 'Antwerpen', coordinates: [4.36, 51.06] },
  { name: 'De Teut', province: 'Limburg', coordinates: [5.39, 50.98] },
];

export default natureAreas;